import React, {Component} from 'react';
import Icon from './Icon.js';
import Dot from './Dot.js';
import Slider from 'react-slick';
import icon1 from '../assets/icons/icon1.svg';
import icon2 from '../assets/icons/icon2.svg';
import icon3 from '../assets/icons/icon3.svg';
import icon4 from '../assets/icons/icon4.svg';
import icon5 from '../assets/icons/icon5.svg';
import icon6 from '../assets/icons/icon6.svg';

import step1 from '../assets/images/img-step1@2x.png';
import step2 from '../assets/images/img-step2@2x.png';
import step3 from '../assets/images/img-step3@2x.png';
import ScrollReveal from 'scrollreveal'
import {Timeline, message} from 'antd';
import Typed from 'typed.js';

import '../styles/Home.scss';
message.config({
    top: 100
});

class Home extends Component {
    state = {
        lawshram: ["A lawyer seeking remote work?", "Practising law after a break?", "Looking to stay abreast of current trends in law?", "A fresh law graduate impatient to start your career?", "A sole practitioner looking to outsource work?", "A lawyer at a small firm wanting to scale virtually?"],
        email: '',
        name:'',
        message: '',
        Emailerrors: '',
        Messageerror: '',
        notificationMessage:false,
        oldSlide: 0,
        activeSlide: 0,
        activeSlide2: 0

    }
    learnMore = (e) => {
        e.preventDefault();
        let bodyContent = document.getElementById('learn');
        window.scrollTo({
            top: bodyContent.offsetTop ,
            behavior: "smooth"
        })
    }

    scrollChange = (current, next) => {
        this.setState({activeSlide: next, oldSlide: current}, () => {
        })
    }

    componentDidMount() {
        ScrollReveal().reveal('.card', {distance: '130px', origin: 'bottom', duration: 1000, reset: true});//scroll fade in
        ScrollReveal().reveal('#footer', {opacity: '1', duration: 1000, reset: true});//scroll fade in
        window.scrollTo(0, 0);
        const options = {
            strings: this.state.lawshram,
            typeSpeed: 100,
            loop: true,
            backSpeed: 0,
        };
        // this.el refers to the <span> in the render() method
        this.typed = new Typed(this.el, options);
        let contact = document.getElementById('contactUs');
        let lawshramWorks = document.getElementById('lawshramWorks');
        if (this.props.match.params.targetId) {
            if (this.props.match.params.targetId === 'contact-us') {
                window.scrollTo({
                    top: contact.offsetTop ,
                    behavior: "smooth"
                })
            } else {
                window.scrollTo({
                    top: lawshramWorks.offsetTop ,
                    behavior: "smooth"
                })
            }
        }

    }


    handleClick = (value, e) => {

        this.slider && this.slider.slickGoTo(value);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.match.params.targetId) {
            let contact = document.getElementById('contactUs');
            let lawshramWorks = document.getElementById('lawshramWorks');

            if (nextProps.match.params.targetId === 'contact-us') {

                window.scrollTo({
                    top: contact.offsetTop ,
                    behavior: "smooth"
                })
            } else {
                window.scrollTo({
                    top: lawshramWorks.offsetTop,
                    behavior: "smooth"
                })
            }
        }
    }

    //handleChange
    handleChange = (e, name) => {
        let formValue = {};
        formValue[name] = e.target.value;
        this.setState(formValue);
    }
//submit message
    handleSubmit = (e) => {

        e.preventDefault();
        if (!(this.state.Emailerrors)) {
            // TODO make ajax call

            let postdata={
                name:this.state.name,
                email:this.state.email,
                message:this.state.message
            }
            fetch('/rest/noauth/enquiry',{
                method: 'POST',
                body: JSON.stringify(postdata),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
            }).then((res)=>{
                console.log(res);
                this.setState({
                    notificationMessage:true
                })
                setTimeout(()=>{
                    this.setState({
                        notificationMessage:false
                    })
                },2000);
            }).catch(error => {
                console.log(error, 'error');
            });
            setTimeout(()=>{
                this.setState({
                    name: '',
                    email: '',
                    message: '',
                })
            },2000);
        }
    }


    validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        if (this.state.email !== '') {
            if (re.test(email)) {
                this.setState({
                    Emailerrors: ""
                });
            } else {
                this.setState({
                    Emailerrors: "Email is not valid"
                });
            }
        }
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            vertical: true,
            easing: "ease-in",
            useTransform: false,
            beforeChange: this.scrollChange

        };

        return (
            <div className="container">
                {   this.state.notificationMessage &&
                    <div className="notification">
                        <span>Successfully Sent</span>
                    </div>
                }
                <main className="main-wrapper ">
                    <div className="welcome-container contents-align">
                        <section className="law-work-wrapper" id="law-work-wrapper">
                            <div className="law-work-content">
                                <h1 className="welcome-title sec-title">Law On The Go</h1>
                                <p className="welcome-content ">Work anytime, anywhere</p>
                            </div>
                            <div className="welcome-btns">
                                <div className="learn-about">
                                    <span  className="learn-more" onClick={this.learnMore}>Learn More</span>
                                </div>
                                <div className="lawshram-login">
                                    <a href="https://lawshram.com/login" className="login">Login</a>
                                </div>
                            </div>
                        </section>
                        <section className="landing-image-container">
                            {/*<img src={landingImage} className="landing-image"/>*/}
                            <div className="landing-image">

                            </div>
                        </section>
                    </div>
                    <div className="body-content" id="learn">
                        <section className="sec-1 contents-align">
                            <p className="sec-title">What is Lawshram?</p>
                            <p className="sec-1-content">Lawshram is a lawyer-to-lawyer ecosystem that enables lawyers
                                to work anywhere, anytime. It helps you build your career at your own pace, without
                                compromising your financial and professional goals.</p>
                        </section>
                        <section className="sec-2 contents-align">
                            <div className="inner-sec-2">
                                <p className="sec-title">Who uses Lawshram?</p>
                                <section className="are-you-wrapper">
                                    <div className="type-wrap">
                                        <h4 className="are-you">Are you</h4>

                                        <span
                                            className="type-wrap-text"
                                            ref={(el) => {
                                                this.el = el;
                                            }}
                                        />
                                    </div>

                                    <p className="start-connect">
                                        Start connecting with fellow Lawshram users and strengthen your practice!
                                    </p>
                                </section>

                            </div>
                        </section>
                        <section className="sec-3 contents-align" id="cardLawshram">
                            <div className="sec-3-header">
                                <p className="sec-title">What can Lawshram do for you?</p>
                                <p className="easy-for">Lawshram makes it easy for you to</p>
                            </div>
                            <div className="card-container">
                                <div className="card bounce-up">
                                    <div className="subject">
                                        <Icon type={icon1}/>
                                        <span className="icon-desc">Define your work hours</span>
                                    </div>
                                </div>
                                <div className="card bounce-up">
                                    <div className="subject">
                                        <Icon type={icon2}/>
                                        <span className="icon-desc">Build your virtual practice</span>
                                    </div>

                                </div>
                                <div className="card bounce-up">
                                    <div className="subject">
                                        <Icon type={icon3}/>

                                        <span className="icon-desc">Work from wherever you choose to</span>
                                    </div>
                                </div>
                                <div className="card bounce-up">
                                    <div className="subject">
                                        <Icon type={icon4}/>

                                        <span className="icon-desc">Scale virtually and increase your bottom line</span>
                                    </div>
                                </div>
                                <div className="card bounce-up">
                                    <div className="subject">
                                        <Icon type={icon5}/>

                                        <span className="icon-desc">Delegate work to fellow lawyers or associates</span>
                                    </div>
                                </div>
                                <div className="card bounce-up">
                                    <div className="subject">
                                        <Icon type={icon6}/>

                                        <span
                                            className="icon-desc">Get access to current trends and topics in law</span>
                                    </div>
                                </div>

                            </div>

                        </section>

                        <section className="sec-4" id="lawshramWorks">

                            <div className="lawshram-works-container">

                                <p className="sec-title">How does Lawshram work?</p>
                                <div className="slicker-wrapper">
                                    <div className="slider-handler">

                                        <Timeline>
                                            <Timeline.Item id="trigger"
                                                           dot={<Dot active={this.state.activeSlide === 0} dataIndex={0}
                                                                     onDotClick={this.handleClick}
                                                                     value={this.state.activeSlide}/>}><p
                                                className={this.state.activeSlide === 0 ? 'step-active' : 'step'}>STEP
                                                1</p>
                                                {this.state.activeSlide === 0 &&
                                                <div className="step-desc">A Lawshram user sends you a personal
                                                    invite to
                                                    join Lawshram</div>}
                                            </Timeline.Item>
                                            <Timeline.Item id="trigger"
                                                           dot={<Dot active={this.state.activeSlide === 1} dataIndex={1}
                                                                     onDotClick={this.handleClick}
                                                                     value={this.state.activeSlide}/>}><p
                                                className={this.state.activeSlide === 1 ? 'step-active' : 'step'}>Step
                                                2</p>
                                                {this.state.activeSlide === 1 && <div className="step-desc"> You
                                                    get an exclusive mail invitation from Lawshram</div>}
                                            </Timeline.Item>

                                            <Timeline.Item id="trigger"
                                                           dot={<Dot active={this.state.activeSlide === 2} dataIndex={2}
                                                                     onDotClick={this.handleClick}
                                                                     value={this.state.activeSlide}/>}><p
                                                className={this.state.activeSlide === 2 ? 'step-active' : 'step'}>Step
                                                3</p>
                                                {this.state.activeSlide === 2 && <div className="step-desc">Click
                                                    on the <span
                                                        className="step3-connect">Connect with Lawyers</span> button on
                                                    the mail, and practice law
                                                    on
                                                    the go</div>}</Timeline.Item>
                                        </Timeline>

                                    </div>
                                    <Slider ref={slider => (this.slider = slider)} {...settings}>
                                        <div>
                                            <div className="img-slider">
                                                <img src={step1} className="slider-images" alt="invites user"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="img-slider">
                                                <img src={step2} className="slider-images" alt="invitation mail from lawshram"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="img-slider">
                                                <img src={step3} className="slider-images" alt="welcome TLP"/>
                                            </div>
                                        </div>
                                    </Slider>

                                </div>

                            </div>
                        </section>


                        <section className="sec-5" id="contactUs">
                            <div className="connect-us-container contents-align">
                                <div className="connect-us-header">
                                    <p className="sec-title">
                                        Connect with us
                                    </p>
                                    <p className="connect-sub-title">Currently, Lawshram works through exclusive invites
                                        only.</p>
                                </div>
                                <div className="message-container">
                                    <div className="message-box">
                                        <p className="message-title">However, if you are interested in becoming a
                                            Lawshram user, please tell
                                            us why, and we will get back to you.</p>
                                        <form className="form-fields">
                                            <input type="text" className="textbox" placeholder="Your name" name="name"
                                                   onChange={(event) => {
                                                       this.handleChange(event, 'name')
                                                   }} value={this.state.name} autoComplete="off"/>
                                            <input type="email" name="email"
                                                   onFocus={() => {
                                                       this.setState({Emailerrors: ''})
                                                   }}
                                                   onBlur={(event) => {
                                                       this.validateEmail(event.target.value)
                                                   }}
                                                   onChange={e => this.handleChange(e, 'email')}
                                                   value={this.state.email} placeholder="Your email" className="textbox"
                                                   autoComplete="off" required/>
                                            <span style={{color: "red"}}>{this.state.Emailerrors}</span>
                                            <textarea maxLength="200" name="message"
                                                      onChange={e => this.handleChange(e, 'message')}
                                                      value={this.state.message} className="textarea"
                                                      placeholder="Please write your message here"/>
                                            <span style={{color: "red"}}>{this.state.Messageerror}</span>

                                        </form>

                                    </div>
                                    <div className="submit">
                                        <button
                                            disabled={!(this.state.email&& this.state.name&& this.state.message)} className="submit-btn"
                                                onClick={this.handleSubmit}>Submit
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </section>
                    </div>
                </main>
            </div>
        )
    }
}

export default Home;